import { prefixObjectValues } from '../../utils';
const form = {
  title: 'title',
  providerCategory: 'provider-category',
  specialty: 'specialty',
  subspecialties: 'subspecialties',
  renewable: 'renewable',
  startDate: 'start-date',
  endDate: 'end-date',
  numShifts: 'fte-shifts-per-year',
  hoursPerShift: 'hours-per-shift',
  totalShifts: 'total-shifts',
  totalHours: 'total-hours',
  compType: 'comp-type',
  avgBaseHourlyRate: 'avg-base-hourly-rate',
  avgRateWithDiff: 'avg-rate-with-diff',
  totalContractValue: 'total-contract-value',
  weekdayShifts: 'weekday-shifts',
  weekendShifts: 'weekend-shifts',
  holidayShifts: 'holiday-shifts',
  weekDayCallShifts: 'weekday-call-shifts',
  weekEndCallShift: 'weekend-call-shifts',
  holidayCallShifts: 'holiday-call-shifts',
  diffCost: 'diff-cost',
  callDiffCost: 'call-diff-cost',
  feeDisclaimer: 'fee-disclaimer',
};
export default prefixObjectValues(form, 'review-info');
